import type * as Types from '../../graphql/types.d'

import type { ProfileFragment } from '../fragments/generated/ProfileFragment'
import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never }>

export type CurrentUserQuery = { __typename?: 'Query' } & {
  currentUser: { __typename?: 'User' } & Pick<
    Types.User,
    | 'id'
    | 'email'
    | 'emailVerified'
    | 'username'
    | 'fullName'
    | 'pictureURL'
    | 'waitListedAt'
    | 'waitListPosition'
    | 'airheartDeveloper'
  > & {
      intercomSettings: { __typename?: 'IntercomUserData' } & Pick<
        Types.IntercomUserData,
        'email' | 'user_id' | 'user_hash' | 'wait_list_position' | 'created_at' | 'app_id' | 'name'
      >
      profile?: Types.Maybe<{ __typename?: 'UserProfile' } & ProfileFragment>
    }
}

export const CurrentUserDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pictureURL' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waitListedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'waitListPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'airheartDeveloper' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'intercomSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'user_hash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'wait_list_position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'app_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Profile' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Profile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'familyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'givenName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nationality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tiktokHandle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode
